<template>
  <activity-month-summary-table />
</template>

<script>
import ActivityMonthSummaryTable from '@/ux/components/activities/ActivityMonthSummaryTable.vue';
export default {
  name: 'activity-month-summary-view',
  components: {
    ActivityMonthSummaryTable,
  },
};
</script>

<style lang="scss" scoped>
</style>